// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","389":"04fdfc91","455":"c81af333","857":"9ec5e701","977":"1fa8c7fd"}[chunkId] + ".chunk.js";
};